/* Malali — carrousels horizontaux des sections malali-*.
   Chaque carrousel : un conteneur [data-mll-carousel] qui contient
   - la piste [data-mll-scroller] (défile au doigt nativement),
   - des flèches optionnelles [data-mll-prev] / [data-mll-next].
   En plus : on peut attraper la piste à la souris et la faire glisser (ordinateur, éditeur Shopify). */
(() => {
  const init = (root) => {
    if (root.dataset.mllReady) return;
    const rail = root.querySelector('[data-mll-scroller]');
    if (!rail) return;
    root.dataset.mllReady = '1';
    const prevs = root.querySelectorAll('[data-mll-prev]');
    const nexts = root.querySelectorAll('[data-mll-next]');
    const bars = root.querySelectorAll('[data-mll-progress]');
    const gap = () => parseFloat(getComputedStyle(rail).columnGap) || 0;
    const step = () => (rail.firstElementChild?.getBoundingClientRect().width || 300) + gap();

    const sync = () => {
      const atStart = rail.scrollLeft < 4;
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      prevs.forEach((b) => (b.disabled = atStart));
      nexts.forEach((b) => (b.disabled = atEnd));
      root.classList.toggle('mll-carousel--static', atStart && atEnd);
      const max = rail.scrollWidth - rail.clientWidth;
      bars.forEach((bar) => {
        bar.style.setProperty('--mll-p-size', Math.min(1, rail.clientWidth / rail.scrollWidth).toFixed(3));
        bar.style.setProperty('--mll-p-pos', max > 0 ? (rail.scrollLeft / max).toFixed(3) : 0);
      });
    };
    prevs.forEach((b) => b.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' })));
    nexts.forEach((b) => b.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' })));
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    // Glisser à la souris (le tactile garde le défilement natif)
    let down = false, moved = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; rail.classList.add('is-dragging'); }
      if (moved) rail.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      rail.classList.remove('is-dragging');
    });
    // Un glisser ne doit pas ouvrir le lien sous la souris
    rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    rail.addEventListener('dragstart', (e) => e.preventDefault());
  };

  const scan = () => document.querySelectorAll('[data-mll-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  // Éditeur Shopify : les sections sont rechargées à chaque modification
  document.addEventListener('shopify:section:load', scan);
})();
